<template>
  <transition name="fade">
    <div v-if="informativo" class="tw-w-full tw-flex tw-justify-between tw-items-center tw-px-2.5 tw-text-white tw-text-center tw-px-2.5 tw-rounded-md tw-py-4 tw-bg-jrRed-50 tw-font-new">
      <span v-html="message_informativo"></span>
      <span class="tw-cursor-pointer" @click="alertHidden"><i class="icon-close tw-text-xs"></i></span>
    </div>
  </transition>
</template>
<script>
    export default {
        name: 'MensagemBoxLeilao',
        props: ['message_informativo','informativo'],
        methods: {
            alertHidden (ev) { // ESCONDER BOX DE ALERT ONLCLICK
                ev.currentTarget.parentNode.style = 'display:none;'
            }
        }
    }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/MensagemBoxLeilao.vue